import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types/global';

const styles: ComponentStylesProps<boolean> = {
  productLineCheckbox: {
    '& label': { display: 'flex', alignItems: 'center', cursor: 'pointer' },
  },
  plansWrapper: (isPLineWithItems) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    '& label': {
      display: 'flex',
      alignItems: 'center',
      cursor: isPLineWithItems ? 'not-allowed' : 'pointer',
    },
  }),
  productLineTitle: {
    margin: 0,
    color: colors.neutral[900],
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
